module.exports = __webpack_public_path__ + "static/media/kc1.20478872.png";